import { P } from '../../theme/tokens';

const directionLabel = (r) => (r.direction === 'outbound' ? 'Outbound' : 'Inbound');
const handledByLabel = (r, assistantName) => (r.handledBy === 'team' ? 'Team' : assistantName);

const caller = {
  key: 'caller',
  header: 'Caller',
  render: (r) => ({ kind: 'stacked', text: r.name, sub: [r.role, r.language].filter(Boolean).join(' · ') || r.phone, strong: true })
};

export const columns = (assistantName = 'Assistant') => [
  {
    key: 'when',
    header: 'Time',
    width: '96px',
    render: (r) => ({ kind: 'stacked', text: r.time, sub: r.date, strong: true, nowrap: true, tabular: true })
  },
  { key: 'type', header: 'Type', width: '124px', render: (r) => ({ kind: 'pill', text: r.type.label, color: r.type.color }) },
  {
    key: 'direction',
    header: 'Direction',
    hideOnPhone: true,
    width: '112px',
    render: (r) => ({ kind: 'pill', text: directionLabel(r), color: r.direction === 'outbound' ? P.subtle : P.info })
  },
  {
    key: 'handledBy',
    header: 'Handled by',
    hideOnPhone: true,
    width: '120px',
    render: (r) => ({ kind: 'pill', text: handledByLabel(r, assistantName), color: r.handledBy === 'team' ? P.success : P.purple })
  },
  caller,
  { key: 'property', header: 'Property / Unit', render: (r) => ({ kind: 'text', text: r.property || '—' }) },
  { key: 'summary', header: 'Summary', hideOnPhone: true, render: (r) => ({ kind: 'text', text: r.summary || '—', ellipsis: Boolean(r.summary) }) },
  { key: 'duration', header: 'Length', width: '64px', align: 'right', hideOnPhone: true, render: (r) => ({ kind: 'text', text: r.duration, nowrap: true, tabular: true }) }
];

export const csvColumns = (assistantName = 'Assistant') => [
  { header: 'Date', value: (r) => (r.startedAt ? new Date(r.startedAt).toLocaleDateString('en-US') : '') },
  { header: 'Time', value: (r) => r.time },
  { header: 'Type', value: (r) => r.type.label },
  { header: 'Direction', value: (r) => directionLabel(r) },
  { header: 'Handled by', value: (r) => handledByLabel(r, assistantName) },
  { header: 'Caller', value: (r) => r.name },
  { header: 'Role', value: (r) => r.role },
  { header: 'Phone', value: (r) => r.phone },
  { header: 'Property / Unit', value: (r) => r.property },
  { header: 'Summary', value: (r) => r.summary },
  { header: 'Action item', value: (r) => r.action },
  { header: 'Length', value: (r) => r.duration }
];
